
(function () {
    'use strict';

    angular.module('customeDirectivesModule')
           .directive('npAdvanceSearch', npAdvanceSearch);

    function npAdvanceSearch() {
        var directive = {
            restrict: 'EA',
            templateUrl: paths.AdvanceSearchView,
            scope: {
                showToggleSearchPanel: '=showToggleSearchPanel'
            },
            link: linkFunction,
            controller: ['$scope', '$state', 'documentTemplateService', controller],
            controllerAs: 'vm'
        };

        return directive;

        function linkFunction(scope, el, attr, ctrl) {
        };

        function controller($scope, $state, documentTemplateService) {
            var vm = this;

            vm.translation = globalResources;
            vm.advanceSearchKeyword = '';
            vm.documentTypes = [];
            vm.selectedDocType = 0;
            vm.datetime = {
                fromDate: null,
                toDate: null,
                isView: false
            };
            vm.filterOptionNeededMessage = globalResources.FilterOptionNeededMessage;
			vm.toggleFlag = false;

			vm.today = new Date();

            vm.toggleSearchPanel = toggleSearchPanel;
            vm.initAdvanceSearchData = initAdvanceSearchData;
            vm.onAdvanceSearch = onAdvanceSearch;

            function toggleSearchPanel() {
                vm.toggleFlag = !vm.toggleFlag;
                if (!$scope.showToggleSearchPanel) {
                    vm.toggleFlag = true;
                }
            };

            function initAdvanceSearchData() {
                if (vm.documentTypes.length == 0) {
                    documentTemplateService.getDocumentTemplate()
                                           .then(function (data) {
                                               vm.documentTypes = data;
                                               var firstItem = { id: 0, name: '' }
                                               data.splice(0, 0, firstItem);
                                           });
                }
            };

            function onAdvanceSearch() {
                if (vm.selectedDocType != 0 || vm.datetime.toDate != null || vm.datetime.fromDate != null || vm.advanceSearchKeyword != '') {
                    vm.filterOptionNeededMessage = '';
                    $state.go(handbookActions.SearchResultAction, {
                        keyword: vm.advanceSearchKeyword,
                        searchInContents: 1,
                        template: vm.selectedDocType,
                        fromDate: vm.datetime.fromDate != null ? vm.datetime.fromDate.getTime() : null,
                        toDate: vm.datetime.toDate != null ? vm.datetime.toDate.getTime() : null,
                        type: 3
                    });
                }
                else {
                    vm.filterOptionNeededMessage = globalResources.FilterOptionNeededMessage;
                }
            };
        };
    };

})();